import React from "react";

const variants = {
  primary:
    "px-7 py-4 rounded-full border-none bg-brand-orange text-white font-medium text-base cursor-pointer hover:bg-brand-orange-hover text-balance",
  secondary:
    "px-[30px] py-4 rounded-full border-none bg-brand-purple text-white font-medium text-base cursor-pointer hover:bg-brand-purple-hover",
  outline:
    "px-6 py-3.5 rounded-full border-[1.5px] border-border-badge bg-white text-text-dark  font-medium text-[15px] cursor-pointer hover:bg-surface-card",
  link: "px-0.5 py-1.5 border-none bg-transparent  font-normal text-sm text-brand-purple underline underline-offset-[3px] cursor-pointer hover:text-brand-purple-hover",
  ghost:
    "px-0.5 py-1.5 border-none bg-transparent text-[15px] text-text-muted underline underline-offset-[3px] cursor-pointer ",
  block:
    "w-full py-4 px-6 rounded-[18px] border-none bg-brand-orange text-white  font-medium text-[clamp(16px,3.4vw,19px)] leading-[1.3] cursor-pointer hover:bg-brand-orange-hover",
  "block-purple":
    "w-full py-[19px] px-6 rounded-[20px] border-none bg-brand-orange text-white  font-medium text-[clamp(15px,3.2vw,18px)] cursor-pointer leading-[1.3] hover:bg-brand-orange-hover",
};

export default function UIButton({
  variant = "primary",
  children,
  disabled = false,
  className = "",
  ...props
}) {
  return (
    <button
      type="button"
      disabled={disabled}
      className={`${variants[variant] || variants.primary} ${
        disabled ? "opacity-60 cursor-not-allowed" : ""
      } ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
